import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import {
  WebhookDeliveriesResponse,
  WebhookDeliveriesParams,
} from 'interfaces/webhook-delivery'

export default function useGetPartnerWebhookDeliveries(
  partnerIntegrationId: string,
  params?: WebhookDeliveriesParams
) {
  const queryParams = new URLSearchParams()

  if (params?.after_id)
    queryParams.append('after_id', params.after_id.toString())
  if (params?.before_id)
    queryParams.append('before_id', params.before_id.toString())
  if (params?.per_page)
    queryParams.append('per_page', params.per_page.toString())
  if (params?.status) queryParams.append('status', params.status)
  if (params?.event_type) queryParams.append('event_type', params.event_type)
  if (params?.start_date) queryParams.append('start_date', params.start_date)
  if (params?.end_date) queryParams.append('end_date', params.end_date)

  const queryString = queryParams.toString()
  const url = `${BASE_API_URL}/admin/api/v2/partner_integrations/${partnerIntegrationId}/webhook_deliveries${
    queryString ? `?${queryString}` : ''
  }`

  return useQuery<WebhookDeliveriesResponse, Error>(
    ['partnerWebhookDeliveries', partnerIntegrationId, params],
    async () => {
      const response = await fetch(url, {
        method: API_METHODS.GET,
        headers: apiHeaders(store.getState()),
      })

      if (!response.ok) {
        throw new Error('Failed to fetch webhook deliveries')
      }

      return response.json()
    },
    {
      enabled: !!partnerIntegrationId,
      keepPreviousData: true, // Keep previous data while fetching new page
    }
  )
}
